import * as React from 'react';
import { Icon } from 'office-ui-fabric-react';
import { jsx as _jsx } from "react/jsx-runtime";
export let StatusIconName = /*#__PURE__*/function (StatusIconName) {
  StatusIconName["Pending"] = "HourGlass";
  StatusIconName["Complete"] = "Completed";
  StatusIconName["NotRequired"] = "Blocked";
  return StatusIconName;
}({});
export let StatusColor = /*#__PURE__*/function (StatusColor) {
  StatusColor["Pending"] = "Gray";
  StatusColor["Complete"] = "ForestGreen";
  StatusColor["NotRequired"] = "Gray";
  return StatusColor;
}({});
export const StatusIcon = /*#__PURE__*/React.memo(_ref => {
  let {
    name
  } = _ref;
  return /*#__PURE__*/_jsx(Icon, {
    iconName: name
  });
});